import styled from 'styled-components';

export const LogoIcon = styled.img`
  width: 40px;
  height: 48px;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  color: $#407BFF;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  gap: 4px;
`;
